import { LitElement, html } from '@lit'

class MobileMenuPanel extends LitElement {
  constructor() {
    super()
    
    this.$container = this.querySelector('.mobile-menu__container')
    this.parentItems = this.querySelectorAll('.js-mobile-parent-item')
    this.subPanels = this.querySelectorAll('.mobile-menu__sub-panel')
    this.closeSubpanelBtn = this.querySelector('.js-submenu-close-button')
    this.$parentLinkTitle = this.querySelector('.js-parent-menu-title')

    this._handleSubMenuOpen = this._handleSubMenuOpen.bind(this)
    this._handleSubMenuClose = this._handleSubMenuClose.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    for (const item of this.parentItems) {
      item.addEventListener('click', (e) => {
        this._handleSubMenuOpen(e)
      })
    }

    this.closeSubpanelBtn.addEventListener('click', this._handleSubMenuClose)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    for (const item of this.parentItems) {
      item.removeEventListener('click', (e) => {
        this._handleSubMenuOpen(e)
      })
    }
    this.closeSubpanelBtn.removeEventListener('click', this._handleSubMenuClose)
  }

  _handleSubMenuOpen = (e) => {
    e.preventDefault()

    const targetId = e.target?.getAttribute('data-target') || ''
    const title = e.target?.getAttribute('data-title') || ''
    if (targetId) {
      for (const item of this.subPanels) {
        const panelId = item.getAttribute('data-panel-id')
        if (panelId === targetId) item.classList.remove('unvisible')
        else item.classList.add('unvisible')
      }
    }

    this.$parentLinkTitle.innerHTML = title
    this.$container.classList.add('mobile-submenu__opened')
  }

  _handleSubMenuClose = () => {
    this.$container.classList.remove('mobile-submenu__opened')
    for (const item of this.subPanels) {
      item.classList.add('unvisible')
    }
  }

  render() {
    return html`
      <slot></slot>
    `
  }
}

customElements.define('mobile-menu-panel', MobileMenuPanel)
